var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.662 2.656a8.385 8.385 0 01-2.402.658A4.196 4.196 0 0020.1 1c-.82.488-1.719.83-2.656 1.015a4.182 4.182 0 00-7.126 3.814 11.874 11.874 0 01-8.62-4.37 4.168 4.168 0 00-.566 2.103c0 1.45.738 2.73 1.86 3.48a4.168 4.168 0 01-1.894-.522v.052a4.185 4.185 0 003.355 4.1 4.208 4.208 0 01-1.89.073A4.185 4.185 0 006.47 13.65a8.393 8.393 0 01-6.19 1.732 11.83 11.83 0 006.41 1.88c7.692 0 11.9-6.373 11.9-11.9 0-.18-.006-.362-.014-.54a8.497 8.497 0 002.087-2.165v-.001z"
  })));
}
export default SvgTwitter;